<div class="ispm-3d-segment-viewer" #prostateViewer
></div>
